import React from 'react';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';

const PhoneFilter = <PhoneInput
    label='filters.components.phone.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='phone'
/>;

export default PhoneFilter;


// WEBPACK FOOTER //
// ./src/components/form/filters/PhoneFilter.js